import AbstractController from '../src/services/ControllersRepository/AbstractController';
import UserRolesUpdateFormPage from '../views/user-roles/UserRolesUpdateFormPage';
import UserRolesCreateFormPage from '../views/user-roles/UserRolesCreateFormPage';

export default class UserRoles extends AbstractController {
    protected controllerName = 'UserRoles';

    protected getDefaultUpdateFormComponent() {
        return UserRolesUpdateFormPage;
    }

    protected getDefaultCreateFormComponent() {
        return UserRolesCreateFormPage;
    }
}
